import * as _ from 'underscore';

import { DataSources } from '../resources/Datasources';
import { ContentSubplaceCtrl, IContentSubplaceResolve, IContentSubplaceScope } from './ContentSubplaceCtrl';
import { ContentSwitchChoice, SwitchableContentWithUrlParamCtrl } from './SwitchableContentWithUrlParamCtrl';


class DatasourcesListCtrl {

  public static $inject = ['$controller', '$scope'];

  public static SubplaceName = 'datasources';

  constructor($controller: ng.IControllerService,
              $scope: IContentSubplaceScope) {

    const resolve: IContentSubplaceResolve = {
      subplace: $scope.place.subplace(DatasourcesListCtrl.SubplaceName),
      shouldFetchDetails: DataSources.isPublished
    };

    const locals = _.extend({}, resolve, { $scope });
    $controller(ContentSubplaceCtrl, locals);
  }
}

class DataConnectionsListCtrl {

  public static $inject = ['$controller', '$scope'];

  public static SubplaceName = 'connections';

  constructor($controller: ng.IControllerService,
              $scope: IContentSubplaceScope) {

    const resolve: IContentSubplaceResolve = {
      subplace: $scope.place.subplace(DataConnectionsListCtrl.SubplaceName),
      shouldFetchDetails: () => false
    };

    const locals = _.extend({}, resolve, { $scope });
    $controller(ContentSubplaceCtrl, locals);
  }
}

const DatasourcesContentChoices: ContentSwitchChoice[] = [
  {
    name: DatasourcesListCtrl.SubplaceName,
    templateUrl: 'dataGridSubplaceWithFilterPanel.html',
    controller: DatasourcesListCtrl
  },
  {
    name: DataConnectionsListCtrl.SubplaceName,
    templateUrl: 'dataGridSubplaceWithFilterPanel.html',
    controller: DataConnectionsListCtrl
  }
];

const DatasourcesInWorkbookContentChoices: ContentSwitchChoice[] = [
  {
    name: DatasourcesListCtrl.SubplaceName,
    templateUrl: 'dataGridSubplaceWithoutFilterPanel.html',
    controller: DatasourcesListCtrl
  },
  {
    name: DataConnectionsListCtrl.SubplaceName,
    templateUrl: 'dataGridSubplaceWithoutFilterPanel.html',
    controller: DataConnectionsListCtrl
  }
];


const ContentSwitchUrlKey = 'viewContentType';


export const DatasourcesCtrl = SwitchableContentWithUrlParamCtrl(DatasourcesContentChoices, ContentSwitchUrlKey);
export const DatasourcesInWorkbookCtrl = SwitchableContentWithUrlParamCtrl(DatasourcesInWorkbookContentChoices, ContentSwitchUrlKey);
export const DatasourcesTemplate = SwitchableContentWithUrlParamCtrl.Template;
